import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { preferenceActions } from '../../../actions';
import useDispatch from '../../../hooks/useDispatch';
import { usePreferences } from '../../../hooks/usePreferences';
import { PriceChartPeriod } from '../../../shared/types';
import {
  DL_SWITCH_CLASS_NAME,
  DL_SWITCH_LEAD_CLASS_NAME,
  DL_SWITCH_LINE_WRAPPER_CLASS_NAME,
} from '../PriceViewer';

const ChartPeriodSwitch: React.FC<{
  wrapAnalytics: (dataKey: string, callback: () => void) => () => void;
}> = ({ wrapAnalytics }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { unit, minuteUnit, period } = usePreferences();

  return (
    <>
      {unit === 'minute' ? (
        <div className={DL_SWITCH_LINE_WRAPPER_CLASS_NAME}>
          {['1m', '3m', '5m', '15m', '1h'].map((theMinuteUnit, i) => (
            <div
              key={`minute-unit-${theMinuteUnit}`}
              className={classNames(DL_SWITCH_CLASS_NAME, {
                checked: minuteUnit === theMinuteUnit,
                [DL_SWITCH_LEAD_CLASS_NAME]: i === 0,
              })}
              onClick={wrapAnalytics(`minute-unit-${theMinuteUnit}`, () =>
                dispatch(
                  preferenceActions.setPriceViewerMinuteUnit(theMinuteUnit)
                )
              )}
            >
              {t(`minute-unit-${theMinuteUnit}`)}
            </div>
          ))}
        </div>
      ) : (
        <div className={DL_SWITCH_LINE_WRAPPER_CLASS_NAME}>
          {['1m', '3m', '6m', '1y', 'max'].map(
            (thePeriod: PriceChartPeriod, i) => (
              <div
                key={`period-${thePeriod}`}
                className={classNames(DL_SWITCH_CLASS_NAME, {
                  [DL_SWITCH_LEAD_CLASS_NAME]: i === 0,
                  checked: period === thePeriod,
                })}
                onClick={wrapAnalytics(`period-${thePeriod}`, () =>
                  dispatch(preferenceActions.setPriceViewerPeriod(thePeriod))
                )}
              >
                {t(thePeriod)}
              </div>
            )
          )}
        </div>
      )}
    </>
  );
};

export default ChartPeriodSwitch;
